// noinspection JSUnusedGlobalSymbols

'use client';

import {Observable, Subject} from 'rxjs';
import _ from 'lodash';

import {$store} from "../global";

export class EventHandler {
  public events: any = {
    networkOnline: {
      name: 'event:network:online',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    networkOffline: {
      name: 'event:network:offline',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    signedIn: {
      name: 'event:user:signed:in',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    signedOut: {
      name: 'event:user:signed:out',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    windowResize: {
      name: 'event:window:resize',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    heartbeat: {
      name: 'server:event:heartbeat',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    presenceChanged: {
      name: 'server:event:user:presence:changed',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    profileSaved: {
      name: 'server:event:user:profile:saved',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    configChanged: {
      name: 'event:config:changed',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    socketConnected: {
      name: 'event:socket:connected',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    socketReconnected: {
      name: 'event:socket:connected',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    socketDisconnected: {
      name: 'event:socket:disconnected',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    dbReady: {
      name: 'event:db:ready',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    setUserData: {
      name: 'event:set:user:data',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    userDataChange: {
      name: 'event:user:data:change',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    feedChange: {
      name: 'event:feed:change',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    syncChange: {
      name: 'event:sync:change',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    userDataSynced: {
      name: 'event:user:data:synced',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    userDataFeedStarted: {
      name: 'event:user:data:feed:started',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    dataReady: {
      name: 'event:data:ready',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    deviceReady: {
      name: 'event:device:ready',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    configReady: {
      name: 'event:config:ready',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
    storeReady: {
      name: 'event:store:ready',
      subject: new Subject(),
      get event(): Observable<any> {
        return this.subject.asObservable();
      }
    },
  };

  constructor() {
  }

  private static publish(event: any, data?: any): void {
    event.subject.next(data);
  }

  public $b(event: any, data?: any, log: boolean = true): void {
    EventHandler.publish(event, data);
    if (log) {
      _.logEvent(event.name);
    }
  }

  public ifOnline(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.App.isOnline) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if ($store.App.isOnline) {
              resolve();
            } else {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.networkOnline.event.subscribe(resolve);
      }
    });
  }

  public ifSignedIn(): Promise<void> {
    return new Promise((resolve) => {
      if (_.get($store, 'User.signedIn$.value', false)) {
        resolve();

      } else {
        this.events.signedIn.event.subscribe(resolve);
      }
    });
  }

  public ifSignedOut(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.User.signedOut) {
        resolve();

      } else {
        this.events.signedOut.event.subscribe(resolve);
      }
    });
  }

  public ifDeviceReady(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.App.deviceReady) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.App.deviceReady) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.deviceReady.event.subscribe(resolve);
      }
    });
  }

  public ifStoreReady(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.App.storeReady) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.App.storeReady) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.storeReady.event.subscribe(resolve);
      }
    });
  }

  public ifConfigReady(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.App.configReady) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.App.configReady) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.configReady.event.subscribe(resolve);
      }
    });
  }

  public ifDbReady(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.DB.dbReady) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.DB.dbReady) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.dbReady.event.subscribe(resolve);
      }
    });
  }

  public ifFeedStarted(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.DB.feedStarted) {
        resolve();

      } else {
        this.events.feedStarted.event.subscribe(resolve);
      }
    });
  }

  public ifFeedCancelled(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.DB.feedCancelled) {
        resolve();

      } else {
        this.events.feedCancelled.event.subscribe(resolve);
      }
    });
  }

  public ifSyncStarted(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.DB.syncStarted) {
        resolve();

      } else {
        this.events.syncStarted.event.subscribe(resolve);
      }
    });
  }

  public ifSyncComplete(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.DB.syncComplete) {
        resolve();

      } else {
        this.events.syncComplete.event.subscribe(resolve);
      }
    });
  }

  public ifSyncCancelled(): Promise<void> {
    return new Promise((resolve) => {
      if ($store.DB.syncCancelled) {
        resolve();

      } else {
        this.events.syncCancelled.event.subscribe(resolve);
      }
    });
  }

  public ifDesignSynced(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.DB.designSynced) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.DB.designSynced) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.designSynced.event.subscribe(resolve);
      }
    });
  }

  public ifDataReady(timeout = false, interval = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if ($store.DB.dataReady) {
        resolve();

      } else {
        if (timeout) {
          const t = setTimeout(() => {
            if (!$store.DB.dataReady) {
              reject();
            }
            clearTimeout(t);
          }, (interval || $store.Static.config.app.defaultTimeout));
        }
        this.events.dataReady.event.subscribe(resolve);
      }
    });
  }
}
